export default class Accordion {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Toggles an accordion
  //===========================================================================

  toggleAccordion(e) {
    const $accordionHeader = $(e.currentTarget);
    const $accordion       = $accordionHeader.closest('.js-accordion');
    const disableAccordion = $accordion.hasClass('accordion-mobile') && window.innerWidth > 750;

    if ($accordionHeader.is('a')) {
      e.preventDefault();
    }

    if (!disableAccordion) {
      if ($accordionHeader.hasClass('open')) {
        this.closeAccordion($accordion, $accordionHeader);
      } else {
        this.openAccordion($accordion, $accordionHeader);
      }
    }
  }

  //===========================================================================
  // Opens an accordion
  //===========================================================================

  openAccordion($accordion, $accordionHeader) {
    const $accordionHeaders  = $accordion.find('.js-accordion-header');
    const $accordionContent  = $accordion.find('.js-accordion-content');
    const $accordionsWrapper = $accordion.closest('.js-accordions');

    this.closeAllAccordions($accordionsWrapper);
    $accordion.addClass('accordion-active');
    $accordionHeaders.removeClass('open');
    $accordionHeader.addClass('open');
    $accordionContent.slideDown(400);
  }

  //===========================================================================
  // Closes an accordion
  //===========================================================================

  closeAccordion($accordion, $accordionHeader) {
    const $accordionHeaders = $accordion.find('.js-accordion-header');
    const $accordionContent = $accordion.find('.js-accordion-content');

    $accordion.removeClass('accordion-active');
    $accordionHeaders.removeClass('open');
    $accordionContent.slideUp(400);
  }

  //===========================================================================
  // Triggers accordion close on a link click
  //===========================================================================

  closeAccordionOnClick(e) {
    const $target = $(e.currentTarget);
    const $accordion = $target.closest('.js-accordion');
    const $accordionHeader = $accordion.find('.js-accordion-header');
    const disableAccordion = $accordion.hasClass('accordion-mobile') && window.innerWidth > 750;

    if ($target.is('a')) {
      e.preventDefault();
    }

    if (!disableAccordion) {
      this.closeAccordion($accordion, $accordionHeader);
    }
  }

  //===========================================================================
  // Closes all accordions
  //===========================================================================

  closeAllAccordions($accordionsWrapper) {
    $accordionsWrapper.find('.js-accordion-header').removeClass('open');
    $accordionsWrapper.find('.js-accordion-content').slideUp(400);
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-accordion-header', this.toggleAccordion.bind(this));
    $(document).on('click', '.js-close-accordion', this.closeAccordionOnClick.bind(this));
  }
}
